import ApiService from '../../../../../services/ApiService'
import FormatDate from '../../../../../Utils/FormatDate'
import Manage from './components/manage.vue'

export default {
  name: 'unitaryAvoidedCosts',

  data() {
    return {
      apiService: new ApiService(),
      show: false,
      loading: false,
      items: [],
      currentItem: {},
      unidades: [],
      setores: [],
      centrosCusto: [],
      naturezas: [],
      unidLoading: false,
      setorLoading: false,
      centroCustoLoading: false,
      naturezaLoading: false,
      sizes: [10, 30, 90, 180],
      filter: {
        unidadeId: null,
        departmentId: null,
        costCenterId: null,
        natureId: null,
        institutionId: null,
        page: 1,
        pageSize: 10,
        totalItems: 0,
        totalPages: 0,
      },
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
          sortable: false,
        },
        {
          text: 'Natureza',
          align: 'center',
          value: 'avoidedCostNature.nature',
        },
        {
          text: 'Data',
          align: 'center',
          value: 'date',
        },
        {
          text: 'Valor',
          align: 'center',
          value: 'cost',
        },
        {
          text: 'Descrição',
          align: 'center',
          value: 'description',
        },
        {
          text: 'Unidade',
          align: 'center',
          value: 'unidade.name',
        },
        {
          text: 'Setor',
          align: 'center',
          value: 'department.name',
        },
        {
          text: 'Centro de Custo',
          align: 'center',
          value: 'costCenter.name',
        },
        {
          text: 'Data de criação',
          align: 'center',
          value: 'createdAt',
        },
        {
          text: '',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
      institution: {},
      deleteDialog: false,
      deleteKey: false,
      user: {},
      manageDialog: false,
      manageKey: false,
      currentAvoidedCost: {},
    }
  },

  components: {
    Manage,
  },

  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.filter.institutionId = this.institution.id

    this.list()
    this.getUnidades()
    this.getSetores()
    this.getCentrosCusto()
    this.getNaturezas()
  },

  methods: {
    openManage(item) {
      this.currentItem = item
      this.manageKey = !this.manageKey
      this.manageDialog = true
    },

    formatCurrency(value) {
      if (value != null) {
        return `$ ${value.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      }
      return '0,00'
    },

    uploadDocument(avoidedCost) {
      this.currentAvoidedCost = avoidedCost
      sessionStorage.clear()

      const avoidedCostForUpload = {
        id: avoidedCost.id,
        description: avoidedCost.description,
        cost: avoidedCost.cost,
      }
      sessionStorage.setItem(
        'avoidedCost',
        JSON.stringify(avoidedCostForUpload)
      )

      const routeData = this.$router.resolve({ path: '/uploadDocument' })
      window.open(routeData.href, '_blank')
    },

    openDelete(item) {
      this.currentItem = item
      this.deleteKey = !this.deleteKey
      this.deleteDialog = true
    },

    remove() {
      this.loading = true
      this.apiService
        .delete(`avoidedCost/delete?id=${this.currentItem.id}`)
        .then(() => {
          this.list()
          this.$toast.success(this.$t('Item excluído com sucesso!'))
          this.loading = false
          this.deleteDialog = false
        })
        .catch(() => {
          this.loading = false
          this.deleteDialog = false
        })
    },

    async getUnidades() {
      this.unidLoading = true
      await this.apiService
        .get(`unidade/listByUserAndInstitution/${this.institution.id}`)
        .then((response) => {
          this.unidades = response.content
          this.unidLoading = false
        })
        .catch(() => {
          this.unidLoading = false
        })
    },

    async getSetores() {
      this.setorLoading = true
      await this.apiService
        .get(`department/list/${this.institution.id}`)
        .then((response) => {
          this.setores = response.content
          this.setorLoading = false
        })
        .catch(() => {
          this.setorLoading = false
        })
    },

    async getCentrosCusto() {
      this.centroCustoLoading = true
      
      let endpoint
      
      if (!this.filter.unidadeId) {
        // Se não há unidade selecionada, buscar todos os centros de custo da instituição
        endpoint = `costCenter/listActive/${this.institution.id}`
      } else {
        // Se há unidade selecionada, filtrar por unidade
        endpoint = `costCenter/listActiveByUnidade/${this.institution.id}/${this.filter.unidadeId}`
      }
      
      await this.apiService
        .get(endpoint)
        .then((response) => {
          this.centrosCusto = response.content
          this.centroCustoLoading = false
        })
        .catch(() => {
          this.centroCustoLoading = false
        })
    },

    async getNaturezas() {
      this.naturezaLoading = true
      await this.apiService
        .get(`AvoidedCostNature/list/${this.institution.id}`)
        .then((response) => {
          this.naturezas = response.content
          this.naturezaLoading = false
        })
        .catch(() => {
          this.naturezaLoading = false
        })
    },

    formatDate(date) {
      return FormatDate.dateTime(date)
    },

    applyFilter() {
      if (this.$refs.form.validate()) {
        this.list()
      }
    },

    reset() {
      this.filter.unidadeId = null
      this.filter.departmentId = null
      this.filter.costCenterId = null
      this.filter.natureId = null
      this.filter.page = 1
      this.list()
    },

    list() {
      this.loading = true
      this.filter.type = 0

      this.apiService
        .post('avoidedCost/list/paginate', this.filter)
        .then((response) => {
          this.loading = false
          this.items = response.content.data

          this.items.forEach(async (item) => {
            try {
              const docsResponse = await this.apiService.get(
                `avoidedCost/documents/${item.id}`
              )
              this.$set(item, 'uploadDocuments', docsResponse.content || [])
            } catch (error) {
              this.$set(item, 'uploadDocuments', [])
            }
          })

          const pager = response.content.pager
          this.filter.page = pager.currentPage
          this.filter.pageSize = pager.pageSize
          this.filter.totalItems = pager.totalItems
          this.filter.totalPages = pager.totalPages
        })
        .catch(() => {
          this.loading = false
        })
    },
  },

  watch: {
    'filter.pageSize': {
      deep: true,
      handler() {
        this.list()
      },
    },
    'filter.page': {
      deep: true,
      handler() {
        this.list()
      },
    },
    'filter.unidadeId'() {
      // Recarregar centros de custo quando unidade mudar
      this.getCentrosCusto()
      // Limpar centro de custo selecionado quando unidade mudar
      this.filter.costCenterId = null
    },
  },
}
